<template>
  <div class="app-container">
    <list ref="list" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/cashier/balancesummer/list";

export default {
  name: "balancesummer",
  mixins: [curdMixins],
  components: {
    list,
  },
  mounted() {},
  methods: {},
};
</script>